import React, { useCallback } from "react";
import { Dialog, DialogTitle, IconButton } from "@mui/material";
import { CloseIcon } from "../../../../../components/Icon";
import { Subtitle } from "../../../../../components/Titles/FormTitles";
import TimesheetForm from "../index";

const TimeEntryDrawer = ({
	PaperComponent,
	openTimeEntryModal,
	setOpenTimeEntryModal,
	handleChangeTimeEntryGuid,
	handleSetEmployeeGuid,
	fromTimeEntriesList,
	fromDashboard,
	handleEditMode,
	timeSheetGuid,
	timeEntryGuid,
	resetFields,
	refetchData,
	fromTimesheet,
	fromProfile,
	description,
	selectedTask,
	refetchTasks,
	refetchTask,
	handleFetchTree,
	handleDeselect,
	synced,
	editMode,
	employees,
	employeeLoading,
	myTime,
	group,
	t,
	billable,
	disabled,
	fromReport,
	fromSelectedTaskFromDashboard,
}) => {
	// Stable close handler
	const handleCloseModal = useCallback(() => {
		setOpenTimeEntryModal(false);
		refetchData?.();
		handleEditMode?.(false);
		refetchTask?.();
		handleFetchTree?.();
		sessionStorage.removeItem("unsavedChanges");
	}, [
		setOpenTimeEntryModal,
		refetchData,
		handleEditMode,
		refetchTask,
		handleFetchTree,
	]);

	// Icon button close logic
	const handleIconClose = useCallback(() => {
		if (refetchTasks && !fromDashboard && !fromTimeEntriesList) {
			refetchTasks();
		}
		handleChangeTimeEntryGuid?.(null);
		handleDeselect?.(false);
		handleCloseModal();
	}, [
		refetchTasks,
		fromDashboard,
		fromTimeEntriesList,
		handleChangeTimeEntryGuid,
		handleDeselect,
		handleCloseModal,
	]);

	return (
		<Dialog
			onClose={(event, reason) => {
				if (reason === "backdropClick") return;
				handleChangeTimeEntryGuid?.(null);
				handleDeselect?.(false);
				handleEditMode?.(false);
				handleCloseModal();
			}}
			PaperComponent={PaperComponent}
			open={openTimeEntryModal}
		>
			<DialogTitle
				style={{
					cursor: "move",
					borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
				}}
				id="draggable-dialog-title"
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<Subtitle
						style={{
							textAlign: "left",
							fontFamily: "poppins !important",
							fontSize: "16px",
						}}
					>
						{!fromDashboard
							? t("timesheet.drawer.title")
							: editMode
							? t("timesheet.drawer.title.edit")
							: t("timesheet.drawer.title.create")}
					</Subtitle>
					<IconButton onClick={handleIconClose}>
						<CloseIcon color="#9e9e9e" width="24" stroke="1.5" />
					</IconButton>
				</div>
			</DialogTitle>
			<TimesheetForm
				timeSheetGuid={timeSheetGuid}
				timeEntryGuid={timeEntryGuid}
				description={description}
				synced={synced}
				disabled={disabled}
				editMode={editMode}
				employees={employees}
				employeeLoading={employeeLoading}
				resetFields={resetFields}
				refetchData={refetchData}
				fromTimesheet={fromTimesheet}
				selectedTask={selectedTask}
				fromProfile={fromProfile}
				handleEditMode={handleEditMode}
				handleChangeTimeEntryGuid={handleChangeTimeEntryGuid}
				handleSetEmployeeGuid={handleSetEmployeeGuid}
				fromDashboard={fromDashboard}
				handleDeselect={handleDeselect}
				handleCloseTimeEntryModal={handleCloseModal}
				myTime={myTime}
				group={group}
				taskBillable={billable}
				fromReport={fromReport}
				fromSelectedTaskFromDashboard={fromSelectedTaskFromDashboard}
			/>
		</Dialog>
	);
};

export default TimeEntryDrawer;
